var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceMonitoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.5 32.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25024",
    "data-name": "Path 25024",
    d: "M29.131,1.25H5.339A4.087,4.087,0,0,0,1.25,5.339V23.183a4.087,4.087,0,0,0,4.089,4.089h6.007l-.922,3.717h-2.1a1.115,1.115,0,0,0,0,2.23H26.172a1.115,1.115,0,0,0,0-2.23h-2.1l-.922-3.717h6.007a4.087,4.087,0,0,0,4.089-4.089V5.339A4.087,4.087,0,0,0,29.161,1.25ZM21.756,30.99H12.715l.922-3.717h7.182l.922,3.717Zm9.234-7.807a1.859,1.859,0,0,1-1.859,1.859H5.339A1.859,1.859,0,0,1,3.48,23.183V5.339A1.859,1.859,0,0,1,5.339,3.48H29.131A1.859,1.859,0,0,1,30.99,5.339ZM27.272,15.57A9.924,9.924,0,0,1,25.8,20.789a1.121,1.121,0,0,1-.952.535,1.18,1.18,0,0,1-.58-.164,1.129,1.129,0,0,1-.372-1.532,7.651,7.651,0,0,0,1.145-4.059,7.807,7.807,0,1,0-15.613,0,7.651,7.651,0,0,0,1.145,4.059,1.114,1.114,0,0,1-1.9,1.16A9.924,9.924,0,0,1,7.2,15.57a10.037,10.037,0,1,1,20.074,0ZM21.25,13.012l-2.112,5.264a2.579,2.579,0,0,1,.7,1.755,2.6,2.6,0,0,1-5.2,0,2.571,2.571,0,0,1,2.439-2.587l2.112-5.264A1.111,1.111,0,1,1,21.25,13Z",
    transform: "translate(-1 -1)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceMonitoring);
export default __webpack_public_path__ + "static/media/PerformanceMonitoring.46397292f0825a8af96b31db9854e984.svg";
export { ForwardRef as ReactComponent };